var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.schedulePopup)?_c('FreshChatSchedulePopup',{attrs:{"schedulePopupText":_vm.schedulePopupText},on:{"close":function($event){_vm.schedulePopup = false}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }